import { useState, FunctionComponent } from 'react';
import CircleQuestionMarkEmptyIcon from 'dibs-icons/exports/legacy/CircleQuestionMarkEmpty';
import CircleQuestionMarkFilledIcon from 'dibs-icons/exports/legacy/CircleQuestionMarkFilled';

type Props = {
    className?: string;
};

const HoverableQuestionMarkIcon: FunctionComponent<Props> = ({ className = '' }) => {
    const [isMouseOn, setIsMouseOn] = useState(false);

    return (
        <div onMouseEnter={() => setIsMouseOn(true)} onMouseLeave={() => setIsMouseOn(false)}>
            {isMouseOn ? (
                <CircleQuestionMarkFilledIcon className={className} />
            ) : (
                <CircleQuestionMarkEmptyIcon className={className} />
            )}
        </div>
    );
};

export default HoverableQuestionMarkIcon;
